import { render, staticRenderFns } from "./SenderAddress.vue?vue&type=template&id=cb471608"
import script from "./SenderAddress.vue?vue&type=script&lang=js"
export * from "./SenderAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports